import { collection, getDocs, addDoc, deleteDoc, doc } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { db, storage } from '../config/firebase/firebaseConfig';
import { AvatarModel } from '../types/avatar';

const AVATARS_COLLECTION = 'avatars';

export class AvatarsService {
  static async loadAvatars(): Promise<AvatarModel[]> {
    try {
      const snapshot = await getDocs(collection(db, AVATARS_COLLECTION));
      const avatars: AvatarModel[] = [];

      snapshot.forEach((doc) => {
        const data = doc.data();
        avatars.push({
          id: doc.id,
          photoUrl: data.photoUrl,
        });
      });

      return avatars;
    } catch (error) {
      console.error('Error loading avatars:', error);
      throw error;
    }
  }

  static async addAvatar(avatar: AvatarModel): Promise<AvatarModel> {
    try {
      const docRef = await addDoc(collection(db, AVATARS_COLLECTION), {
        photoUrl: avatar.photoUrl,
      });

      return {
        ...avatar,
        id: docRef.id,
      };
    } catch (error) {
      console.error('Error adding avatar:', error);
      throw error;
    }
  }

  static async deleteAvatar(avatarId: string): Promise<void> {
    try {
      const docRef = doc(db, AVATARS_COLLECTION, avatarId);
      await deleteDoc(docRef);
    } catch (error) {
      console.error('Error deleting avatar:', error);
      throw error;
    }
  }

  static async uploadAvatarImage(file: File): Promise<string> {
    try {
      const fileName = `${Date.now()}_${file.name}`;
      const storageRef = ref(storage, `avatars/${fileName}`);

      const snapshot = await uploadBytes(storageRef, file);
      const downloadURL = await getDownloadURL(snapshot.ref);

      return downloadURL;
    } catch (error) {
      console.error('Error uploading avatar image:', error);
      throw error;
    }
  }
}